import React from "react";
import { Grid } from "semantic-ui-react";
import { convertToDateString, handleAddressValue, handleFormChange, handleGetValueFromId, handleInputType } from "../../../Helpers";
import { addTimestamp } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { getFeatureFlags } from "../../constants/LocalServerConstants";
import { ILoanDetailSectionInput } from "../../interfaces/Loan";
import BCFormInput from "../../ui/BCFormInput";
import BCValidationMessage from "../../ui/BCValidationMessage";

interface ILoanDetailSectionContentProps {
  isGreaterThanMobile: boolean;
  displayObj?: any;
  mainPatchObj?: any;
  setMainPatchObj?: (value: any) => any;
  mainPatchArr?: any;
  setMainPatchArr?: (value: any) => any;
  subPatchObjName?: any;
  subPatchObj: any;
  setSubPatchObj: (value: any) => any;
  isEditMode: boolean;
  handleFormChange: (value: string, field: string, obj: any, setObj: (value: any) => any, type: string, handleCustomFormChange?: any, charLimit?: number, index?: number, objArray?: any) => void;
  index?: number;
  inputs?: ILoanDetailSectionInput[];
  isLoanApplication?: boolean;
  borrowerApplicationInfo?: any;
  invalidProps: any;
  validationGroupName?: any;
}

const UserFeatureFlags = getFeatureFlags();
const BPLoanDetailSectionContent = ({ ...props }: ILoanDetailSectionContentProps) => {
  const handleDisplayValue = (input) => {
    if (input.field && Object.keys(props.subPatchObj).includes(input.field) && props.isEditMode === true) {
      if (input.valueHidden) {
        return input.value;
      }
      else {
        return props.subPatchObj[input.field];
      }
    }
    else {
      return input.value;
    }
  };
  
  const handlePatchFormChange = (value, field, inputType, charLimit : number | undefined = undefined) => {
    const formattedValue = handleInputType(inputType, value, undefined, undefined, 50);
    if (props.displayObj) {
      props.displayObj[field] = formattedValue;
    }
    
    handleFormChange(
      formattedValue,
      field,
      props.subPatchObj,
      props.setSubPatchObj,
      inputType,
      undefined,
      charLimit
    );

    if (props.mainPatchArr && props.setMainPatchArr) {
      const selectedObj = props.mainPatchArr.find(x => x.id === props.subPatchObj.id);
      if (selectedObj) {
        selectedObj[field] = formattedValue;
        props.mainPatchArr.map(oldObj => oldObj.id === selectedObj.id ? {...selectedObj} : oldObj);
      }
      else {
        props.mainPatchArr.push({...props.subPatchObj});
      }

      props.setMainPatchArr([...props.mainPatchArr]);
    }

    if (props.setMainPatchObj && props.mainPatchObj !== props.subPatchObj && props.subPatchObjName) {
      props.mainPatchObj[props.subPatchObjName] = props.subPatchObj;
      props.setMainPatchObj({...props.mainPatchObj});
    }
  };

  const handleAddressFormat = (obj) => {
    const addressObj = {...obj};
    return `${handleAddressValue({
      address: addressObj.address ? addressObj.address : "",
      city: addressObj.cityName,
      state: addressObj.stateName,
      zip: addressObj.zip,
    })}`;
  };

  const handleOriginalValueDisplay = (input) => {
    if (props.isLoanApplication && (input.original !== 0 && input.original) && input.value !== input.original) {
      if (input.originalIdValueFrom) {
        return `${handleGetValueFromId(input.originalIdValueFrom, input.original)}`;
      }
      else if (input.address && (handleAddressFormat({...input.value}) !== handleAddressFormat({...input.original}))) {
        return handleAddressFormat({...input.original});
      }
      else if (input.address && (handleAddressFormat({...input.value}) === handleAddressFormat({...input.original}))) {
        return false;
      }
      else if (input.calendar) {
        return `${convertToDateString(input.original, "calendar")} `;
      }
      else {
        return `${input.original}`;
      }
    }
    else {
      return false;
    }
  };

  return (
    <Grid>
      <Grid.Row className="details-row">
        {props.inputs?.map((input, i) => {
          if (input && (input.label || input.actionLabel) && (input.value || (!input.readonly)) && input.condition !== false) {
            return (
              <Grid.Column key={`ApplicationDetailSectionInput-${i}`} className="primary-details" width={props.isGreaterThanMobile ? input.size : 16}>
                {input.dropdown ? <BCFormInput
                  labelClass="gmr-background-label"
                  type="dropdown"
                  label={input.label}
                  actionText={input.actionText}
                  actionLabel={input.actionLabel}
                  labelAction={input.labelAction}
                  actionLabelClass={input.actionLabelClass}
                  placeholder="Please Select..."
                  value={handleDisplayValue(input)}
                  obj={props.subPatchObj}
                  field={input.field}
                  dropdownOptions={input.dropdown}
                  handleFormChange={(value, field) => handlePatchFormChange(value, field, input.inputType ? input.inputType : input.unitType === "$" ? GlobalConstants.InputTypes.FLOAT : GlobalConstants.InputTypes.STRING, input.charLimit)}
                  disabled={!props.isEditMode || input.readonly || !props.isLoanApplication}
                  required={input.required}
                />
                : input.inputSuffix ? <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label={input.label}
                  actionText={input.actionText}
                  actionLabel={input.actionLabel}
                  labelAction={input.labelAction}
                  actionLabelClass={input.actionLabelClass}
                  value={handleDisplayValue(input)}
                  obj={props.borrowerApplicationInfo}
                  field={input.field}
                  fieldType={input.fieldType}
                  unitField={input.unitField}
                  dropdownOptions={input.dropdownOptions}
                  handleFormChange={(value: string, field: string) => handlePatchFormChange(value, field, GlobalConstants.InputTypes.INT)}
                  handleSelectFormChange={(value: string, field: string) => handlePatchFormChange(value, field, GlobalConstants.InputTypes.STRING)}
                  disabled={!props.isEditMode || input.readonly || !props.isLoanApplication}
                  defaultUnitValue={input.defaultUnitValue}
                  required={input.required}
              />
                : input.address ? <BCFormInput
                  type={GlobalConstants.FormInputTypes.PLACES}
                  placeDetailsObject={input.placeDetailsObject}
                  label={input.label}
                  labelClass="gmr-background-label"
                  disabled={!props.isEditMode || !props.isLoanApplication}
                  setPlaceDetailsObject={(editPlaceObj) => input.setPlaceDetailsObject(editPlaceObj)}
                  handleFormChange={input.handleFormChange}
                  placeholder="1234 Main Street, Seattle, WA 98052, USA"
                  defaultValue={input.addressObj ? handleAddressValue(input.addressObj) : handleAddressValue({
                    address: input.value.street ? input.value.street : "",
                    city: input.value.cityName,
                    state: input.value.stateName,
                    zip: input.value.zip,
                  })}
                  placeFields={["address", "city", "state", "county", "zip"]}
                  placeFieldsNameOverrides={input.fieldsNameOverridesArray}
                  required={input.required}
                />
                : input.calendar ? <BCFormInput 
                    value={input.valueHidden ? "" : convertToDateString(handleDisplayValue(input), "calendar")}
                    type="calendar"
                    labelClass="gmr-background-label"
                    label={input.label}
                    actionText={input.actionText}
                    actionLabel={input.actionLabel}
                    labelAction={input.labelAction}
                    actionLabelClass={input.actionLabelClass}
                    obj={props.subPatchObj}
                    field={input.field}
                    handleFormChange={(value, field) => handlePatchFormChange(addTimestamp(value), field, GlobalConstants.InputTypes.STRING)}
                    disabled={!props.isEditMode || input.readonly || !props.isLoanApplication || input.valueHidden}
                    required={input.required}
                  />
                  : input.checkbox ? <div className="interior-card-checkbox"><BCFormInput 
                    value={handleDisplayValue(input)}
                    type="checkbox"
                    labelClass="gmr-background-label"
                    label={input.label}
                    obj={props.subPatchObj}
                    field={input.field}
                    handleFormChange={(value, field) => handlePatchFormChange(value, field, GlobalConstants.InputTypes.STRING)}
                    disabled={!props.isEditMode || input.readonly || !props.isLoanApplication || input.valueHidden}
                    required={input.required}
                  /></div>
                  : UserFeatureFlags.IS_RETAIL_PHASE_2 && input.textarea ? <div className="interior-card-checkbox"><BCFormInput 
                    value={handleDisplayValue(input)}
                    type="textarea"
                    labelClass="gmr-background-label"
                    label={input.label}
                    obj={props.subPatchObj}
                    field={input.field}
                    handleFormChange={(value, field) => handlePatchFormChange(value, field, GlobalConstants.InputTypes.STRING)}
                    disabled={!props.isEditMode || input.readonly || !props.isLoanApplication || input.valueHidden}
                    required={input.required}
                  /></div>
                  : <BCFormInput
                    labelClass="gmr-background-label"
                    type="input"
                    label={input.label}
                    actionText={input.actionText}
                    actionLabel={input.actionLabel}
                    labelAction={input.labelAction}
                    actionLabelClass={input.actionLabelClass}
                    value={handleDisplayValue(input)}
                    field={input.field}
                    inputType={input.inputType}
                    fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                      (input.unitType && input.unitType === "%") ? "percent" : null}
                    obj={props.subPatchObj}
                    handleFormChange={(value, field) => input.handleCustomFormChange ? input.handleCustomFormChange(value, field, props.displayObj, props.mainPatchArr, props.setMainPatchArr) : handlePatchFormChange(value, field, input.inputType ? 
                      input.inputType : input.unitType === "socialSecurity" ? GlobalConstants.InputTypes.MASKED : input.unitType === "$" ? 
                      GlobalConstants.InputTypes.FLOAT : GlobalConstants.InputTypes.STRING, input.charLimit)}
                    unitType={input.unitType}
                    disabled={!props.isEditMode || input.readonly || !props.isLoanApplication || input.valueHidden}
                    allowNegativeValue={input.allowNegativeValue}
                    required={input.required}
                  />}
                {<div className="version-dropdown"> 
                  {handleOriginalValueDisplay(input) && `Original: ${handleOriginalValueDisplay(input)}`}
                </div>}
                {(input.required && props.validationGroupName && !input.address) && <BCValidationMessage invalidProps={props.invalidProps} prop={`${props.validationGroupName}-${input.field}`} propText="This field is required."/>}
                {(input.required && props.validationGroupName && input.field === "street") && <BCValidationMessage invalidProps={props.invalidProps} prop={`custom-duplicated-${props.validationGroupName}`} propText="Duplicated street name."/>}
                {(input.required && props.validationGroupName && input.address) && <BCValidationMessage invalidProps={props.invalidProps} prop={`${props.validationGroupName}-zip`} propText="Zip code is required"/>}
                {(input.required && props.validationGroupName && input.addressObj && input.addressObj.zip) && <BCValidationMessage invalidProps={props.invalidProps} prop={`${props.validationGroupName}-${input.addressObj.zip}`} propText="Zip code is required"/>}
                {(input.required && input.inputType && input.inputType === GlobalConstants.InputTypes.INT) && <BCValidationMessage invalidProps={props.invalidProps} prop={`${props.validationGroupName}-invalid-${input.field}`} propText="Please enter number only."/>}
                {props.validationGroupName && <BCValidationMessage invalidProps={props.invalidProps} prop={`${props.validationGroupName}-invalidLength-${input.field}`} propText="Please make sure the length of EIN is 9 digit long."/>}
              </Grid.Column>
            );
          }
          else {
            return null;
          }
        })}
      </Grid.Row>
    </Grid>
  );
};

export default BPLoanDetailSectionContent;